export const assignation = {
    assignableLesson: false,
    isAutoAssignmentForced: true,
};
